import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { CommonService } from 'src/app/services/common.service';
import { Container,Content } from '../../models/data.model';
import { AuthGuardService } from 'src/app/services/authGuard';
import { Router } from '@angular/router';
import { TranslateService, LangChangeEvent } from '@ngx-translate/core';
import { LocalSettingsService } from 'src/app/services/local-settings.service';
import { DataService } from 'src/app/services/data.service';
import { Observable } from 'rxjs';
import { debounceTime, distinctUntilChanged, map } from 'rxjs/operators';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ChangelogComponent } from '../changelog/changelog.component';
import { environment } from 'src/environments/environment';


@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit {

  @ViewChild("menu", { read: ElementRef }) menu: ElementRef;


  constructor(private containerService: CommonService<Container>,
    private contentService: CommonService<Content>, private authService: AuthGuardService, private router: Router,
    private translate: TranslateService, private LocalSettings: LocalSettingsService,
    private dataService: DataService, private modalService: NgbModal) {

  }

  isExpanded = false;
  menuItems: Container[] = [];
  childMenuItems: Content[] = [];
  model: Container = null;
  isUserloggedIn: boolean = false;
  profile: any = null;
  formatter = (x: { tooltip: string }) => x.tooltip;//(result: Container) => result.tooltip;
  currentLangCss: string;

  keyword = 'tooltip';

  ngOnInit(): void {

    this.isUserloggedIn = this.authService.isLoggedIn();
    this.profile = this.authService.getProfile();
    if(!this.profile){
      this.authService.ImLogged(undefined, undefined).then(
      (result)=>{
        // let res = result as boolean;
         if(result)
         {
          this.isUserloggedIn = this.authService.isLoggedIn();
           this.profile = this.authService.getProfile();
           console.log('user profile is', this.profile);

         }

      },
      (error)=>this.router.navigate(['/login']) 
    );
    }
    if (this.menuItems.length === 0)
      this.fetchContainers();

    // this.authService.ImLogged().then(
    //   (result)=>{
    //     // let res = result as boolean;
    //      if(result)
    //      {
    //       this.isUserloggedIn = this.authService.isLoggedIn();
    //       this.profile=this.authService.getProfile();
    //         if(this.menuItems.length === 0)
    //           this.fetchContainers();
    //      }

    //   },
    //   (error)=>this.router.navigate(['/login']) 
    // ); 


    this.getLangCss();
    //console.log('currentlang is : ',lang);
    //console.log('loged in result',this.isLogedIn());
    // this.authService.ImLogged().then(
    //   (result)=>{
    //     // let res = result as boolean;
    //      if(result) this.fetchContainers();

    //   },
    //   (error)=>this.authService.redirectToLogin("login")
    // ); 
    //if (this.authService.ImLogged())
    //this.fetchContainers();
    //else
    //  this.authService.redirectToLogin("login");
  }


  fetchContainers = () => {

    let url = 'api/rest/containers';
    let params = { params: { type: this.menu.nativeElement.id } };
    this.containerService.getData(url, params, false).subscribe(result => {
      //console.log("result", result);
      if (result != null) {
        //console.log('this is menuItems : ', result);
        this.menuItems = result as Container[];
        this.menuItems = this.menuItems.sort((a, b) => a['order'] > b['order'] ? 1 : a['order'] === b['order'] ? 0 : -1);

        this.fetchSubItems().then(()=>{
          this.dataService.fillMenuItems(this.menuItems);
        });

        // this.fetchContent().then(()=>{
        //   this.dataService.fillMenuItems(this.menuItems);
        // });      
      }

    }, error => console.error(error));
  }



  private fetchSubItems() {
    return new Promise(resolve => {
      let resolveCounter = 0;
      for(let i=0;i<this.menuItems.length;i++){
        this.fetchSubMenu(this.menuItems[i]).then(() => {
          resolveCounter++;   
          if(resolveCounter === this.menuItems.length){
            resolve();
          }
        });
      }
      
      
      // this.menuItems.forEach((header,index) => {

      // });
      
    })


  }

  logout(): void {
    let url = 'api/auth/logout';
    this.containerService.postData(url, {}, false).subscribe(result => {
      this.authService.setLoggedIn(false);
      this.isUserloggedIn = false;
      this.menuItems = [];
      this.childMenuItems = [];

      //cambiato redirect per il logout
      window.location.href = environment.openIdUrl + environment.openIdlogoutUrl 

      //console.log("result", result);
      //this.router.navigate(['/login']);

    }, error => console.error(error));


  }

  fetchSubMenu = (header: Container) => {

    return new Promise((resolve, err) => {
      this.childMenuItems = [];
      let url = 'api/rest/containers/' + header.id + '/contents';
      //let params = { params: { id: this.menuItems[i].id } };
      let params = {};
      this.contentService.getData(url, params, false).subscribe(result => {
        //console.log("result", result);
        if (result != null) {

          let items = result as Content[];
          header.contents = items;
          resolve();
        }

      }, error => {
        console.error(error);
        err();
      });

    });

    
    }





    search = (text$: Observable<string>) =>
      text$.pipe(
        debounceTime(200),
        distinctUntilChanged(),
        map(term => term.length < 2 ? []
          : this.childMenuItems.filter(v => v.tooltip.toLowerCase().indexOf(term.toLowerCase()) > -1).slice(0, 10))
      )


    goToLink = (link$: Content) => {
      window.open(link$.linkedUrl, "_blank")
    }

    onLangChanged = (lang: string) => {
      this.translate.use(lang);
      this.translate.onLangChange.subscribe((event: LangChangeEvent) => {
        this.LocalSettings.setLanguage(lang);
        this.getLangCss();
      });
    }

  private getLangCss() {
    let lang = this.translate.currentLang;
    this.currentLangCss = "flag-icon-" + lang;
  }

  collapse() {
    this.isExpanded = false;
  }

  toggle() {
    this.isExpanded = !this.isExpanded;
  }

  get NavItems() {
    return this.menuItems;
  }

  public trackByFn(index,item){
    if(!item) return null;
    return index;
  }

  openChangelog() {
    const modalRef = this.modalService.open(ChangelogComponent, { windowClass: "myCustomModalClass", backdrop: 'static' });
  }

}
